<script setup>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import SupportButton from "@/components/SupportButton.vue";

import { onBeforeMount, onMounted, ref, watch } from "vue";
import { useRoute } from 'vue-router';

import StaticBar from "./components/StaticBar.vue";

import { overrideDefaultValidatorsMessage } from "@/services/validationSettings.js";

import { useCompanyStore} from "@/stores/companyStore.js";
const companyStore = useCompanyStore();

import { useAuthStore } from "@/stores/authStore.js";
const authService = useAuthStore();

import { useSocketStore } from "@/stores/socketConnectionStore";
const socketService = useSocketStore();

import { useLoadingStore } from "@/stores/loadingStore.js";
const loadingStore = useLoadingStore();

import { useRefreshStore } from '@/stores/refreshStore.js'
const refreshStore = useRefreshStore();

const route = useRoute();

const showSocketError = ref(false);
let socketErrorTimeout = null;

authService.checkCookies();

onBeforeMount(() =>{
  socketService.unauthConnect();
})

watch(() => socketService.isConnected, (isConnected) => {
  if (!authService.isActiveUser) {
    return;
  }

  if (!isConnected) {
    if (socketErrorTimeout) {
      clearTimeout(socketErrorTimeout);
    }
    socketErrorTimeout = setTimeout(() => {
      if (authService.isActiveUser) {
        showSocketError.value = true;
      }
    }, 5000);
  } else {
    if (socketErrorTimeout) {
      clearTimeout(socketErrorTimeout);
      socketErrorTimeout = null;
    }
    showSocketError.value = false;
  }
}, { immediate: true });

overrideDefaultValidatorsMessage();
</script>

<template>
  <div class="d-flex justify-content-center align-items-center bg-light">
    <div class="d-flex flex-column block-main">
      <div v-if="authService.isActiveUser">
        <nav-bar></nav-bar>
      </div>
      <transition name="fade" mode="out-in">
          <router-view class="router-main ps-5 pe-5" />
      </transition>
    </div>
    <Teleport to="body">
      <div class="alerts-block position-fixed bottom-0 end-0">
        <static-bar
          v-if="loadingStore.loading"
          :message="`Выполняется запрос: ${loadingStore.loadingMessage}`"
          :header="'ЗАГРУЗКА'"
          :css-class="'bg-warning'"
          withLoading
          class="m-0"
        ></static-bar>
        <static-bar
          v-if="authService.isActiveUser && showSocketError"
          :message="`Не удается подключится к серверу по адресу: ${ socketService?.host }`"
          :header="'ОШИБКА'"
          :css-class="'bg-danger'"
          class="m-0"
        ></static-bar>
				<static-bar v-for="[key, data] in socketService.success.entries()"
				:message="data.message"
				:header="data.header"
				:css-class="'bg-success'"
				class="m-0"
				></static-bar>
				<static-bar v-for="[key, data] in socketService.error.entries()"
					:message="data.message"
					:header="data.header"
					:css-class="'bg-danger'"
          :sentry="data.sentry"
					class="m-0"
				></static-bar>
				<static-bar v-for="[key, data] in socketService.warning.entries()"
					:message="data.message"
					:header="data.header"
					:css-class="'bg-warning'"
					class="m-0"
				></static-bar>
				<static-bar v-for="[key, data] in socketService.pending.entries()"
					:message="data.message"
					:header="data.header"
					:css-class="'bg-warning'"
					withLoading
					class="m-0"
				></static-bar>
      </div>
      <SupportButton v-if="route.path !== '/'"/>
    </Teleport>
  </div>
</template>

<style>
html {
  overflow-y: scroll;
}
.router-main {
  padding-bottom: 24px;
  padding-top: 24px;
  flex: 1 1 auto;
  padding-left: 56px;
  padding-right: 56px;
}
.block-main {
  min-width: 997px;
  min-height: 100vh;
  width: 100%;
  max-width: 1920px;
  position: relative;
  overflow: hidden;
  background-image: url("/bg_4.png");
  background-size: cover;
  background-attachment: fixed;
}

.block-main::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.block-main > * {
  position: relative;
  z-index: 1;
}

.block-main > :first-child {
  position: relative;
  z-index: 1030;
}

@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .block-main {
    background: none;
  }
  .block-main::before {
    background: none;
    background-image: url("/bg_4.png");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    filter: blur(6px);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
}

.alerts-block{
  z-index: 10000 !important;
  margin-bottom: 38px !important;
  margin-right: 78px !important;
}

.router-main {
  position: relative;
  z-index: 2;
}
.fade-enter-from, .fade-leave-to{
  opacity: 0;
}

.fade-enter-active, .fade-leave-active{
  transition: opacity 0.50s ease-out; 
}
body.hide-b24-btn .b24-widget-button-wrapper,
body.hide-b24-btn .b24-widget-button-outer,
body.hide-b24-btn .b24-widget-button-pulse,
body.hide-b24-btn .b24-widget-button-block {
  display: none !important;
}

</style>
<style>
/* Wider tooltips globally (ensures report table "(?)" tooltips are visible and wrap) */
.v-popper .v-popper__inner {
  max-width: 520px;
  white-space: normal;
  word-wrap: break-word;
}

.v-popper .v-popper__content {
  max-width: 520px;
}
</style>
